<template>
  <form class="native-form" @submit.prevent>
    <slot />
  </form>
</template>

<script setup lang="ts">
import type { NativeFormRules } from "./types";

const props = defineProps<{
  model?: object;
  rules?: NativeFormRules;
}>();

const validate = async (callback: (valid: boolean) => void) => {
  let valid = true;
  let validationMessage = "";
  for (const [key, rules] of Object.entries(props.rules || {})) {
    const value = props.model ? Reflect.get(props.model, key) : undefined;
    for (const rule of rules) {
      if (rule.required && (value === undefined || value === null || value === "")) {
        valid = false;
        validationMessage = rule.message || "请填写必填项";
        break;
      }
      if (typeof value === "string" && rule.min !== undefined && value.length < rule.min) {
        valid = false;
        validationMessage = rule.message || "输入内容过短";
        break;
      }
      if (typeof value === "string" && rule.max !== undefined && value.length > rule.max) {
        valid = false;
        validationMessage = rule.message || "输入内容过长";
        break;
      }
      if (rule.validator) {
        const error = await new Promise<Error | undefined>((resolve) => {
          rule.validator?.(rule, value, resolve);
        });
        if (error) {
          valid = false;
          validationMessage = error.message || rule.message || "输入内容不正确";
          break;
        }
      }
    }
    if (!valid) break;
  }
  if (!valid && typeof window !== "undefined") {
    window.alert(validationMessage || "请检查必填项及输入格式");
  }
  callback(valid);
};

defineExpose({ validate });
</script>

<style>
.native-form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 18px;
}

.native-form-item > label {
  color: #475569;
  font-size: 0.9rem;
  font-weight: 500;
}

.native-form-error {
  color: #c53030;
  font-size: 0.8rem;
}
</style>
